import { styled } from '@mui/material/styles';

export const ErrorWrapper = styled('div')(({ theme }) => ({
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%'
}));
